<template>
	<div class="position-relative height-100dvh">
		<div
			class="h-100"
			:class="showFilter || showExportExcel ? 'card-blur' : ''"
		>
			<div class="mob-back-header justify-content-between">
				<section>
					<img
						@click="goBack"
						class="mr-3"
						src="../../assets/mobile/assprog/mobileBackArrow.svg"
						alt=""
					/>
					Interviews
				</section>
				<img
					@click="showExportExcel = true"
					class="mr-3"
					ref="exportBtn"
					src="../../assets/newdesign/transaction/excel.svg"
					alt=""
				/>
			</div>

			<div class="mob-back-body">
				<div class="trm-white-card">
					<div class="d-flex align-items-center justify-content-between gap-3">
						<div
							class="mob-search-filter position-relative"
							:class="showPublic ? 'w-75' : 'w-100'"
						>
							<b-form-input
								placeholder="Search"
								type="search"
								v-model="searchQuery"
								debounce="500"
								@update="getPanelInterviews()"
								clearable
							></b-form-input>

							<img
								class="mob-search-pos"
								src="../../assets/mobile/assprog/search.svg"
								alt=""
							/>
						</div>
						<div
							@click="showFilter = !showFilter"
							class="mb-black-bold-2 d-flex align-items-center position-relative"
							ref="filterBtn"
						>
							Filter
							<img
								class="ml-1"
								src="../../assets/mobile/assprog/mobFilter.svg"
								alt=""
							/>
							<div v-if="filtered" class="filter-dot"></div>
						</div>
					</div>
					<div
						class="h-100"
						v-if="interviews && interviews.length == 0 && !transactionLoading"
					>
						<div
							class="d-flex flex-column align-items-center justify-content-center h-100"
						>
							<img
								src="../../assets/newdesign/transaction/no-tran.svg"
								alt=""
							/>
							<h4 class="fam-lato fw-LM fs-16 color-black mt-4">
								No results found for "{{ searchQuery || filterText }}"
							</h4>
						</div>
					</div>
					<template v-if="transactionLoading || interviews.length > 0">
						<template v-if="transactionLoading">
							<article
								v-for="i in 10"
								:key="i"
								class="tran-row fam-lato fw-R fs-15 text-blue"
							>
								<div id="hideinmobile" class="tran-blue-bar"></div>
								<section v-for="i in 4" :key="i" class="col-one">
									<b-skeleton class="w-75"></b-skeleton>
								</section>

								<div class="tran-wid-28 d-flex align-items-center">
									<section class="col-six w-25">
										<b-skeleton class="w-75"></b-skeleton>
									</section>
									<section class="col-sev w-25">
										<b-skeleton class="w-75"></b-skeleton>
									</section>
								</div>
								<div id="hideinlaptop" class="d-flex mt-2">
									<div class="width-45">
										<h5 class="fam-mont fw-LM fs-11 text-3A3C40 mb-1">
											Role Name
										</h5>
										<h5
											class="fam-mont fw-M fs-11 text-3A3C40 mb-1 w95 text-truncate"
										>
											<b-skeleton class="w-75"></b-skeleton>
										</h5>
									</div>
									<div class="width-45">
										<h5 class="fam-mont fw-LM fs-11 text-3A3C40 mb-1">
											Skills:
										</h5>
										<h5
											class="fam-mont fw-M fs-11 text-3A3C40 mb-1 w-100 text-truncate"
										>
											<b-skeleton class="w-100"></b-skeleton>
										</h5>
									</div>
								</div>
								<section id="hideinmobile" class="col-eig">
									<b-skeleton class="w-75"></b-skeleton>
								</section>
							</article>
						</template>
						<section class="trm-overflow" @scroll="onScroll" v-else>
							<article
								v-for="(interview, i) in interviews"
								:key="i"
								class="tran-row fam-lato fw-R fs-15 text-blue"
							>
								<section class="col-one">
									<span class="tran-blue-tag">{{
										interview.interviewRequestID
									}}</span>
									<img
										@click="openJobDetails(interview, i)"
										class="pointer"
										id="hideinlaptop"
										src="../../assets/newdesign/home/roundRightArrow.svg"
										alt=""
									/>
								</section>
								<section class="col-two">{{ interview.name }}</section>

								<section class="col-three text-truncate">
									{{ interview.emailID }}
								</section>

								<div class="tran-wid-28 d-flex align-items-center">
									<section class="col-six">
										23.01.2025, 02:00 - 03:00 PM
									</section>
									<section class="col-sev">
										<div class="tran-row-tag">
											<img
												v-if="interview.paymentStatus == 0"
												src="../../assets/newdesign/transaction/red-rupee.svg"
												alt=""
											/>
											<img
												v-if="interview.paymentStatus == 1"
												src="../../assets/newdesign/transaction/money-icon.svg"
												alt=""
											/>
											<img
												v-if="interview.paymentStatus == 2"
												src="../../assets/newdesign/transaction/green-money-icon.svg"
												alt=""
											/>
											{{ interview.interviewInfo.amount }}
										</div>
									</section>
								</div>
								<div id="hideinlaptop" class="d-flex mt-2">
									<div class="width-45">
										<h5 class="fam-mont fw-LM fs-11 text-3A3C40 mb-1">
											Role Name
										</h5>
										<h5
											class="fam-mont fw-M fs-11 text-3A3C40 mb-1 w95 text-truncate"
										>
											{{ interview.role }}
										</h5>
									</div>
									<div>
										<h5 class="fam-mont fw-LM fs-11 text-3A3C40 mb-1">
											Skills:
										</h5>
										<h5
											class="fam-mont fw-M fs-11 text-3A3C40 mb-1 w-100 text-truncate"
										>
											<span>
												{{ interview.skills.slice(0, 2).join(", ") }}</span
											>
											<span v-if="interview.skills.length > 2">
												+{{ interview.skills.length - 2 }} more
											</span>
										</h5>
									</div>
								</div>
							</article>
							<div v-if="loadingMore" class="d-flex justify-content-center">
								<b-spinner label="Loading..."></b-spinner>
							</div>
						</section>
					</template>
				</div>
			</div>
		</div>
		<JobDetailsModal
			v-if="showJobDetailsModal"
			:showJobDetailsModal="showJobDetailsModal"
			:interview="selectedInterview"
			:ongoing="false"
			:level="2"
			:isTransaction="true"
			@close-modal="hideJobDetails()"
		/>
		<Transition name="slidemob">
			<div
				class="filter-box-mob h-unset p-3"
				ref="filter-box-mob"
				v-if="showFilter"
				v-closable="{
					exclude: ['filter-box-mob', 'filterBtn'],
					handler: 'closeFilter',
				}"
			>
				<article class="blue-drag"></article>
				<h5 class="fam-lato fw-B fs-18 text-black mt-3">Filters</h5>
				<div>Status :</div>
				<div class="mob-radio-group panel-radio-fs-14">
					<b-form-group>
						<b-form-radio-group
							size="md"
							:options="options"
							v-model="selectedFilter"
							stacked
						></b-form-radio-group>
					</b-form-group>
				</div>
				<hr class="hr-back" />
				<div class="d-flex align-items-center justify-content-between">
					<article class="mob-cancelBtn w-25">
						<b-button
							class="w-100"
							:disabled="selectedFilter === null"
							@click="resetFilter"
							>Clear</b-button
						>
					</article>
					<article class="mob-addBtn w-25">
						<b-button
							class="w-100"
							:disabled="selectedFilter === null"
							@click="applyFilter"
							>Apply</b-button
						>
					</article>
				</div>
			</div>
		</Transition>
		<Transition name="slidemob">
			<div
				v-if="showExportExcel"
				class="filter-box-mob h-unset p-3"
				ref="export-box-mob"
				v-closable="{
					exclude: ['export-box-mob', 'exportBtn'],
					handler: 'closeExport',
				}"
			>
				<article class="blue-drag"></article>
				<div class="mt-4">
					<label class="teams-label-font fs-14 my-2 w-40">From Date :</label>
					<DateField
						placeholder="From Date"
						:mandatory="false"
						:noLabel="true"
						format="DD-MM-YYYY"
						:id="'from-date'"
						:vmodel="fromDate"
						@select-value="updateFromDate"
						:startDate="null"
					/>
					<label class="teams-label-font fs-14 mb-2 mt-3 w-40">To Date :</label>
					<DateField
						placeholder="To Date"
						:mandatory="false"
						:noLabel="true"
						format="DD-MM-YYYY"
						:id="'to-date'"
						:vmodel="toDate"
						@select-value="updateToDate"
						:startDate="fromDate"
					/>
				</div>
				<hr class="hr-back" />
				<div class="d-flex align-items-center justify-content-end gap-3">
					<article class="mob-cancelBtn w-25">
						<b-button class="w-100" @click="showExportExcel = false"
							>Cancel</b-button
						>
					</article>
					<article class="mob-addBtn w-25">
						<b-button
							class="w-100"
							:disabled="!fromDate || !toDate"
							@click="applyExportFilter"
							>Export</b-button
						>
					</article>
				</div>
			</div>
		</Transition>
	</div>
</template>

<script>
import transactionPage from "@/components/mixin/transactionPage";
export default {
	mixins: [transactionPage],
};
</script>

<style>
.trm-white-card {
	background-color: #ffffff;
	height: 100%;
	border-radius: 4px;
	padding: 12px;
}
.trm-overflow {
	height: calc(100% - 45px);
	overflow: auto;
	margin-top: 10px;
}
</style>
